import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { GetBy } from '../_app/cuchillo/core/Element';
import Default from './Default';
import ArtScene from '../3D/ArtScene';
import BGImage from "../layout/BGImage";
import { Scroll } from '../_app/cuchillo/scroll/Scroll';


export default class Art extends Default {
  constructor() {
    super();
    ArtScene.init(this.container);
  }

  afterShow() {
    super.afterShow();
    ArtScene.animateIn();
  }

  loop() {
    super.loop();
    ArtScene.loop();
  }

  beforeHide() {
    ArtScene.hide();
    super.beforeHide();
  }

  afterHide() {
    ArtScene.dispose();
    super.afterHide();
  }

  resize(__w, __h) {
    super.resize(__w, __h);
    ArtScene.resize();
  }
}

ControllerPage._addPage('page-art', Art);
